import {DatabaseCode, toDatabaseCode} from "./database-code";
import {ValveType, valveType, valveTypes} from "./valve-type";

export type GeofenceTriggerType = DatabaseCode;

const primary: GeofenceTriggerType = {
  code: 'PRIMARY',
  displayValue: {
    id: 'ots.ui.entity.geofencetriggertype.primary',
    defaultMessage: 'Primary',
  },
};

const onSiteStart: GeofenceTriggerType = {
  code: 'ON_SITE_START',
  displayValue: {
    id: 'ots.ui.entity.geofencetriggertype.onsitestart',
    defaultMessage: 'On Site Start',
  },
};

export const geofenceTriggerType = {
  primary,
  onSiteStart,
};

export const geofenceTriggerTypes = Object.values(geofenceTriggerType);

export const toGeofenceTriggerType = (code: string): GeofenceTriggerType => toDatabaseCode(code, geofenceTriggerTypes);
export const toGeofenceTriggerTypeSafely = (code: string | undefined): GeofenceTriggerType | undefined => code ? toDatabaseCode(code, geofenceTriggerTypes) : undefined;
